var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import VueRouter from 'vue-router';
import Vue from 'vue';
import Log from '../logger/Log';
Vue.use(VueRouter);
const TAG = 'router/Router';
class RouterManager {
    constructor(idg) {
        this.idg = idg;
        this.router = new VueRouter();
        this.initHooks();
    }
    initHooks() {
        this.router.beforeEach((to, from, next) => __awaiter(this, void 0, void 0, function* () {
            Log.debug(TAG, 'router beforeEach start');
            try {
                yield this.idg.root.auth.initByStorage();
            }
            catch (e) {
                Log.debug(TAG, 'router beforeEach error', e);
            }
            Log.debug(TAG, 'router beforeEach start');
            next();
        }));
    }
}
export default RouterManager;
